import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { USER_CHANGES } from '../../constants/tableTypes'

const initialState = {
  data: [],
}

const maxBidHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case `REPLACE_TABLE_USER_INFO_${USER_CHANGES}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        USER_CHANGES,
        state,
        action
      )
    default:
      return reducers.auditTable.auditTableReducer(USER_CHANGES)(state, action)
  }
}

export default combineReducers({
  data: maxBidHistoryReducer,
  tableInfo: reducers.auditTableColumnDefinitions(USER_CHANGES),
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(USER_CHANGES, state, action),
})
